import { useNavigate } from "react-router-dom";
import { MessageCircle, Compass } from "lucide-react";

export function pickSuggestion(board, mission) {
  const open = (board.must_dos || []).find((m) => m.status !== "done" && m.link?.goal_id);
  if (open) return { text: open.text, why: open.why || null, goal: open.link?.label?.split(" · ")[0] || null };
  if (mission && mission.status !== "complete" && !mission.done_today) {
    return { text: mission.text, why: `This week's focus: ${mission.count} of ${mission.target} days so far.`, goal: null };
  }
  return null;
}

export function Suggestion({ board, mission, onChooseDirection }) {
  const nav = useNavigate();
  if (!board.goals.length && !board.vision_line) {
    return (
      <div className="card p-5 sm:p-6" data-testid="today-suggestion-empty">
        <span className="eyebrow flex items-center gap-1.5"><Compass className="h-3.5 w-3.5" />Your direction</span>
        <p className="font-display text-xl mt-2 text-[#302A34]">What would you like this month to be about?</p>
        <p className="text-sm text-[#6A646D] mt-1">Choose a direction in your own words. CAMRYN won't pick one for you.</p>
        <button onClick={onChooseDirection} data-testid="today-choose-direction" className="btn-ink mt-4 h-11 px-5 rounded-full text-sm font-semibold">Choose a direction</button>
      </div>
    );
  }
  const s = pickSuggestion(board, mission);
  if (!s) return null;
  return (
    <div className="card p-5 sm:p-6 bg-[#F0EBF2] border-[#E4E1E5]" data-testid="today-suggestion">
      <span className="eyebrow">One idea for today · optional</span>
      <p className="font-display text-xl mt-2 text-[#302A34]" data-testid="today-suggestion-text">{s.text}</p>
      {(s.why || s.goal) && <p className="text-sm text-[#6A646D] mt-1" data-testid="today-suggestion-why">{s.goal ? `Connects to "${s.goal}". ` : ""}{s.why || ""}</p>}
      <button onClick={() => nav("/talk", { state: { fromToday: s } })} data-testid="today-suggestion-talk"
        className="btn-ink mt-4 h-11 px-5 rounded-full text-sm font-semibold inline-flex items-center gap-2"><MessageCircle className="h-4 w-4" />Talk it through</button>
    </div>
  );
}
